// Module
var code = "<md-button class=\"md-raised md-neutral md-big md-button-uppercase\" data-ng-click=\"$ctrl.upload()\">\n    <i class=\"fa fa-camera\"></i> &nbsp\n    Add photos\n</md-button>";
// Exports
module.exports = code;